import { useMediaQuery } from '@mui/material';
import React from 'react';
import * as Styled from '../DocumentPreview.styles';
import { Fieldset } from '../Fieldset/Fieldset';
import * as StyledSummary from './SummaryFieldSet.styles';
import { useTheme } from '@emotion/react';
import { VerticalFieldset } from '../VerticalFieldset/VerticalFieldset';

export const SummaryFieldSet = ({ total, paid, leftToPay }) => {

    const theme = useTheme();
    const isGreaterThanMD = useMediaQuery(theme.breakpoints.up('xxl'));

    return (
        <React.Fragment>
            {isGreaterThanMD && (
                <Styled.RowSpaceBetween>
                    <Styled.VerticalRightAligned sx={{gap:0.5, marginRight:2}}>
                        <StyledSummary.Title>Razem:</StyledSummary.Title>
                        <StyledSummary.Title>Zapłacono:</StyledSummary.Title>
                        <StyledSummary.Title>Pozostało do zapłaty:</StyledSummary.Title>
                    </Styled.VerticalRightAligned>
                    <Styled.VerticalRightAligned sx={{gap:0.5}}>
                        <StyledSummary.Subtitle>{total}</StyledSummary.Subtitle>
                        <StyledSummary.Subtitle>{paid}</StyledSummary.Subtitle>
                        <StyledSummary.Subtitle>{leftToPay}</StyledSummary.Subtitle>
                    </Styled.VerticalRightAligned>
                </Styled.RowSpaceBetween>   
            )}
            {!isGreaterThanMD && (
                <Styled.VerticalLeftAligned sx={{gap:1.5}}>
                    <VerticalFieldset title={'Razem:'} subtitle={total} boldTitle/>
                    <VerticalFieldset title={'Zapłacono:'} subtitle={paid} boldTitle/>
                    <VerticalFieldset title={'Pozostało do zapłaty:'} subtitle={leftToPay} boldTitle/>
                </Styled.VerticalLeftAligned>
            )}            
        </React.Fragment>

            

        // <Styled.VerticalRightAligned>
        //     <Fieldset title={'Razem:'} subtitle={total} />
        //     <Fieldset title={'Zapłacono:'} subtitle={paid} />
        //     <Fieldset title={'Pozostało do zapłaty:'} subtitle={leftToPay} />
        // </Styled.VerticalRightAligned>

    );
  };